



























import { Component, Vue } from "vue-property-decorator";
import DateTime from "@/components/DateTime.vue";
import Weather from "@/components/Weather.vue";

@Component({
  components: {
    DateTime,
    Weather
  }
})
export default class SidePanel extends Vue {
  private location: string;
  constructor() {
    super();
    this.location = this.$route.query.weatherLocation
      ? this.$route.query.weatherLocation[0] || ""
      : "";
  }
}
